import { Grid, Flex, SVG, Text } from '@raskrask-dk/rr-components'
import SheetNTowelIcon from '../../../../assets/icons/company/SheetNTowelIcon.svg'
import ClockIcon from '../../../../assets/icons/company/ClockIcon.svg'
import CalendarRedXIcon from '../../../../assets/icons/company/CalendarWithRedXIcon.svg'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

const CompanyOneOffExtraInfoTemplate = (): ReactElement => {
    const { t } = useTranslation()
    return (
        <Grid gap={16}>
            <Grid gap={4}>
                <Flex alignItems="center">
                    <SVG src={SheetNTowelIcon} />
                    <Text bold>
                        {t('details.form.oneoff.extrainfo.sheetntowel.header')}
                    </Text>
                </Flex>
                <Text>
                    {t('details.form.oneoff.extrainfo.sheetntowel.text')}
                </Text>
            </Grid>
            <Grid gap={4}>
                <Flex alignItems="center">
                    <SVG src={ClockIcon} />
                    <Text bold>
                        {t('details.form.oneoff.extrainfo.time.header')}
                    </Text>
                </Flex>
                <Text>{t('details.form.oneoff.extrainfo.time.text')}</Text>
            </Grid>
            <Grid gap={4}>
                <Flex alignItems="center">
                    <SVG src={CalendarRedXIcon} />
                    <Text bold>
                        {t('details.form.oneoff.extrainfo.cancellation.header')}
                    </Text>
                </Flex>
                <Text>
                    {t('details.form.oneoff.extrainfo.cancellation.text')}
                </Text>
            </Grid>
        </Grid>
    )
}

export default CompanyOneOffExtraInfoTemplate
